import styled from 'styled-components';

import { color } from 'styled-system';

import { ThemeInterface } from '../../theme/ThemeInterface';
import { IS_VENDOR } from '../../consts';
import { theme } from '../../theme';

type SideBarWrapperProps = {
  open: boolean;
  className?: string;
  children: React.ReactNode;
};

type LogoContProps = {
  open: boolean;
};

type LogoProps = {
  open: boolean;
  src: string;
};

type LogoutButtonProps = {
  open: boolean;
};

export const PageWrap = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
  box-sizing: border-box;
`;

export const SideBarWrapper = styled.div<SideBarWrapperProps>`
  ${color};
  top: 0;
  left: 0;
  bottom: 0;
  z-index: ${theme.zIndex[8]};
  display: flex;
  position: fixed;
  max-width: 100%;
  height: 100vh;
  overflow: hidden;
  box-sizing: border-box;
  width: ${props => (props.open ? '250px' : '60px')};
  transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  background: ${IS_VENDOR ? 'white' : 'linear-gradient(320deg, rgba(40, 42, 47, 1) 0%, rgba(51, 53, 61, 1) 100%)'};
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  box-shadow: 1px 0px 5px 1px rgba(0, 0, 0, 0.15);
  ::-webkit-scrollbar {
    display: none;
  }
  & .sidebar-menu-icon {
    font-size: 21px;
    margin-left: 20px;
    transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
  & .nav-link-text-hidden > div > span {
    opacity: 0;
    visibility: hidden;
    width: 0;
    transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
`;

export const VersionCont = styled.div<{ open: boolean }>`
  padding: 20px;
  width: 100%;
  box-sizing: border-box;
  border-top: 1px solid ${props => props.theme.colors.transparentWhite};
  text-align: ${props => (props.open ? 'left' : 'center')};
  background-color: inherit;
`;

export const Logo = styled.img<LogoProps>`
  height: auto;
  max-width: 100%;
  display: inline-block;
  width: ${props => (props.open ? '30%' : 0)};
  margin: ${props => (props.open ? '0 20px 0 0' : '0 -15px 0 0')};
`;

export const LogoCont = styled.div<LogoContProps>`
  height: 70px;
  z-index: ${theme.zIndex[9]};
  display: flex;
  position: fixed;
  position: relative;
  align-items: center;
  box-sizing: border-box;
  border-bottom: 1px solid ${IS_VENDOR ? theme.colors.paleGrey : theme.colors.transparentBlack};
  transition-property: width;
  justify-content: space-between;
  width: ${props => (props.open ? '250px' : '60px')};
  transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  & ${Logo} {
    transition-property: visibility, opacity;
    opacity: ${props => (props.open ? 1 : 0)};
    transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    visibility: ${props => (props.open ? 'visible' : 'hidden')};
  }
`;

export const LogoutButton = styled.div`
  left: 0;
  bottom: 0;
  height: 50px;
  display: flex;
  position: fixed;
  align-items: center;
  justify-content: flex-start;
  background-color: 'transparent';
  border-top: 1px solid rgba('255, 255, 255, 0.6');
  transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  width: ${(props: LogoutButtonProps) => (props.open ? '250px' : '60px')};
  &:hover {
    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    background-color: ${(props: ThemeInterface) => props.theme.colors.putty};
  }
`;



// WEBPACK FOOTER //
// ./src/components/sidebar/StyledElements.tsx